<template>
    <v-sheet class="form-side">
        <v-card-title class="form-side__title">
            <span>도구 목록</span>
            <template v-if="mobile">
                <v-spacer />
                <v-btn text icon tile class="my-n1 mr-n1" @click="$emit('exit')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-card-title>
        <v-divider />
        <v-card-text class="fill-height d-flex flex-column" style="overflow-y: auto">
            <v-expansion-panels flat mandatory>
                <template v-for="side in sides">
                    <side-list v-model="form" v-bind="{ side }" :key="side" />
                </template>
            </v-expansion-panels>
            <side-file v-model="form" @input="emit" class="mt-4" />
        </v-card-text>
    </v-sheet>
</template>

<script>
import { EMPLOYMENT_FIELD_SIDES, initEmploymentForm } from "@/assets/variables";

import SideFile from "./side/side-file.vue";
import SideList from "./side/side-list.vue";

const sides = Object.keys(EMPLOYMENT_FIELD_SIDES);

export default {
    components: {
        SideFile,
        SideList,
    },
    props: {
        value: { type: Object, default: initEmploymentForm },
        mobile: { type: Boolean, default: false },
    },
    data: () => ({
        form: initEmploymentForm(),
        sides,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentForm(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
};
</script>

<style lang="scss" scoped>
.form-side {
    display: flex;
    flex-direction: column;
    height: 100%;

    &__title {
        font-size: 16px !important;
        height: 60px;
    }
}
</style>
